// Import all actions
import * as actions from "../actions/winterPointsActions";
import {
  calculateTableData,
  calculateTableDataForHeating,
  calculateTableDataForCooling,
  calculateTableDataForMixing,
  calculateTableDataForSteamHumidify,
} from "../utils/calculationFunctions";

export const initialState = {
  winterPoints: [
    {
      id: 0,
      temperatureDryBulb: -20,
      temperatureWetBulb: -20.1,
      temperatureDewPoint: 0,
      relativeHumidity: 90,
      absoluteHumidity: 0.6,
      enthalpy: -18.8,
      airFlowHours: 10000,
      airFlowSeconds: 0,
      massFlow: 1.55,
      realFlow: 0,
      airDensity: 1.38,
      usedPower: 0,
      usedWater: 0,
      process: "outdoor",
    },
    {
      id: 1,
      temperatureDryBulb: 20,
      temperatureWetBulb: 12.3,
      temperatureDewPoint: 0,
      relativeHumidity: 40,
      absoluteHumidity: 5.9,
      enthalpy: 35.1,
      airFlowHours: 0,
      airFlowSeconds: 0,
      massFlow: 0,
      realFlow: 0,
      airDensity: 1.18,
      usedPower: 0,
      usedWater: 0,
      process: "indoor",
    },
  ],
};

export default function winterPointsReducer(state = initialState, action) {
  const {
    temperatureDryBulb,
    temperatureWetBulb,
    temperatureDewPoint,
    relativeHumidity,
    absoluteHumidity,
    enthalpy,
    airFlowHours,
    airFlowSeconds,
    massFlow,
    realFlow,
    airDensity,
    usedPower,
    usedWater,
    process,
  } = action;
  const arrayLength = state.winterPoints.length;

  const outdoorPoint = state.winterPoints[0];
  //const pointForCalculation = state.summerPoints[arrayLength - 2];
  const updatedArray = [...state.winterPoints];
  switch (action.type) {
    case actions.SET_INITIAL_STATE:
      return { ...state, winterPoints: initialState.winterPoints };
    /* case actions.ADD_PROCESSPOINT_WINTER:
      return [
        ...state,
        {
          temperatureDryBulb,
          temperatureWetBulb,
          temperatureDewPoint,
          relativeHumidity,
          absoluteHumidity,
          enthalpy,
          airFlowHours,
          airFlowSeconds,
          massFlow,
          realFlow,
          airDensity,
          usedPower,
          usedWater,
          process,
        },
      ];*/
    /* case actions.UPDATE_PROCESSPOINT_WINTER:
      return [
        ...state,
        {
          temperatureDryBulb,
          temperatureWetBulb,
          temperatureDewPoint,
          relativeHumidity,
          absoluteHumidity,
          enthalpy,
          airFlowHours,
          airFlowSeconds,
          massFlow,
          realFlow,
          airDensity,
          usedPower,
          usedWater,
          process,
        },
      ];*/

    case actions.UPDATE_AIRFLOW:
      let outdoorAirFlow = Math.round(
        +action.payload.airFlow * (+action.payload.mixingRatio / 100)
      );
      let indoorAirFlow = Math.round(
        +action.payload.airFlow * ((100 - +action.payload.mixingRatio) / 100)
      );

      let outdoorForChange = updatedArray[0];
      outdoorForChange.airFlowHours =
        action.payload.airFlowUnit === 10
          ? outdoorAirFlow
          : outdoorAirFlow * 3600;
      outdoorForChange.airFlowSeconds =
        action.payload.airFlowUnit === 10
          ? outdoorAirFlow / 3600
          : outdoorAirFlow;
      let indoorForChange = updatedArray[1];
      indoorForChange.airFlowHours =
        action.payload.airFlowUnit === 10
          ? indoorAirFlow
          : indoorAirFlow * 3600;
      indoorForChange.airFlowSeconds =
        action.payload.airFlowUnit === 10
          ? indoorAirFlow / 3600
          : indoorAirFlow;
      updatedArray[0] = outdoorForChange;
      updatedArray[1] = indoorForChange;

      return {
        ...state,
        winterPoints: updatedArray,
      };
    case actions.UPDATE_INDOORPOINT_WINTER:
      const indoorArray = [...state.winterPoints]; // Create a shallow copy of the array
      indoorArray[1] = action.payload; // Update the first element
      return {
        ...state,
        winterPoints: indoorArray,
      };

    case actions.UPDATE_OUTDOORPOINT_WINTER:
      const outdoorArray = [...state.winterPoints]; // Create a shallow copy of the array
      outdoorArray[0] = action.payload; // Update the first element
      return {
        ...state,
        winterPoints: outdoorArray,
      };
    /*  case actions.GET_ARRAY_DATA_WINTER:
      return {
        ...state,
      };*/
    case actions.ADD_NEW_WINTER_PROCESSPOINT:
      const newWinterPoint = {
        id: arrayLength,
        temperatureDryBulb: 0,
        temperatureWetBulb: 0,
        temperatureDewPoint: 0,
        relativeHumidity: 0,
        absoluteHumidity: 0,
        enthalpy: 0,
        airFlowHours: 0,
        airFlowSeconds: 0,
        massFlow: 0,
        realFlow: 0,
        airDensity: 0,
        usedPower: 0,
        usedWater: 0,
        process: "",
      };
      return {
        ...state,
        winterPoints: [...state.winterPoints, newWinterPoint],
      };

    case actions.CHANGE_WINTER_POINT_PROCESS:
      const passedPoint = state.winterPoints.find(
        (item) => item.id === action.payload.processID
      );
      passedPoint.process = action.payload.processName;

      updatedArray[passedPoint.id] = passedPoint;
      return {
        ...state,
        winterPoints: updatedArray,
      };

    case actions.DELETE_PROCESS_POINT:
      let newArray = [];

      newArray = updatedArray
        .filter((item) => item.id !== action.payload)
        .map((item, index) => ({
          ...item,
          id: index,
        }));

      return {
        ...state,
        winterPoints: newArray,
      };

    case actions.ADD_OR_UPDATE_HEATINGPOINT_WINTER:
      const passedHeatingPoint = state.winterPoints.find(
        (item) => item.id === action.payload.processID
      );

      // const outdoorPoint7 = state.winterPoints[0];
      const pointForCalculationHeating =
        state.winterPoints[action.payload.processID - 1];
      //const updatedArray1 = [...state.winterPoints];

      //Kalkulacija parametara za novu tačku
      const {
        temperatureWetBulbCalculated: temperatureWetBulbCalculatedHeating,
        absoluteHumidity: absoluteHumidityHeating,
        relativeHumidity: relativeHumidityHeating,
        enthalpy: enthalpyHeating,
        massFlow: massFlowHeating,
        realFlow: realFlowheating,
        airDensity: airDensityHeating,
        usedPower: usedPowerHeating,
        usedWater: usedWaterHeating,
      } = calculateTableDataForHeating(
        action.payload.heatingTemperature,
        action.payload.elevation,
        passedHeatingPoint.id === 2 ? outdoorPoint : pointForCalculationHeating
      );

      //Kopija niza koja će biti izmenjena

      const newPointHeating = {
        id: passedHeatingPoint.id,
        temperatureDryBulb: +action.payload.heatingTemperature,
        temperatureWetBulb: temperatureWetBulbCalculatedHeating,
        temperatureDewPoint: 0,
        relativeHumidity: relativeHumidityHeating,
        absoluteHumidity:
          passedHeatingPoint.id === 2
            ? outdoorPoint.absoluteHumidity
            : pointForCalculationHeating.absoluteHumidity,
        enthalpy: enthalpyHeating,
        airFlowHours:
          passedHeatingPoint.id === 2
            ? outdoorPoint.airFlowHours
            : pointForCalculationHeating.airFlowHours,
        airFlowSeconds:
          passedHeatingPoint.id === 2
            ? outdoorPoint.airFlowHours / 3600
            : pointForCalculationHeating.airFlowHours / 3600,
        massFlow: massFlowHeating,
        realFlow: realFlowheating,
        airDensity: airDensityHeating,
        usedPower: usedPowerHeating,
        usedWater: usedWaterHeating,
        process: 10,
      };

      updatedArray[passedHeatingPoint.id] = newPointHeating;

      return {
        ...state,
        winterPoints: updatedArray,
      };
    case actions.ADD_OR_UPDATE_COOLINGPOINT_WINTER:
      const passedCoolingPoint = state.winterPoints.find(
        (item) => item.id === action.payload.processID
      );

      const pointForCalculationCooling =
        state.winterPoints[action.payload.processID - 1];
      const {
        temperatureWetBulbCalculated: temperatureWetBulbCalculatedCooling,
        absoluteHumidity: absoluteHumidityCooling,
        relativeHumidity: relativeHumidityCooling,
        enthalpy: enthalpyCooling,
        massFlow: massFlowCooling,
        realFlow: realFlowCooling,
        airDensity: airDensityCooling,
        usedPower: usedPowerCooling,
        usedWater: usedWaterCooling,
      } = calculateTableDataForCooling(
        action.payload.coolingTemperature,
        action.payload.P,
        action.payload.airFlowHours,
        action.payload.airFlowSeconds,
        action.payload.coolerTemperature,
        action.payload.elevation,
        action.payload.maxHumidityInProcess,
        passedCoolingPoint.id === 2 ? outdoorPoint : pointForCalculationCooling
      );

      const newCoolingPoint = {
        id: passedCoolingPoint.id,

        temperatureDryBulb: +action.payload.coolingTemperature,
        temperatureWetBulb: temperatureWetBulbCalculatedCooling,
        temperatureDewPoint: 0,
        relativeHumidity: relativeHumidityCooling,
        absoluteHumidity: absoluteHumidityCooling,
        enthalpy: enthalpyCooling,
        airFlowHours: pointForCalculationCooling.airFlowHours,
        airFlowSeconds: pointForCalculationCooling.airFlowHours / 3600,
        massFlow: massFlowCooling,
        realFlow: realFlowCooling,
        airDensity: airDensityCooling,
        usedPower: usedPowerCooling,
        usedWater: usedWaterCooling,
        process: 20,
      };
      updatedArray[passedCoolingPoint.id] = newCoolingPoint;

      return {
        ...state,
        winterPoints: updatedArray,
      };

    case actions.ADD_OR_UPDATE_MIXINGPOINT_WINTER:
      const passedMixingPoint = state.winterPoints.find(
        (item) => item.id === action.payload.processID
      );

      const lastPoint = state.winterPoints[action.payload.processID - 1];
      const prevLastPoint = state.winterPoints[action.payload.processID - 2];

      const {
        temperatureWetBulbCalculated: temperatureWetBulbCalculatedMixing,
        temperatureDryBulb: temperatureDryBulbMix,
        absoluteHumidity: absoluteHumidityMix,
        relativeHumidity: relativeHumidityMix,
        enthalpy: enthalpyMix,
        massFlow: massFlowMix,
        realFlow: realFlowMix,
        normalFlow: normalFlowMix,
        airDensity: airDensityMix,
        usedPower: usedPowerMix,
        usedWater: usedWaterMix,
      } = calculateTableDataForMixing(
        lastPoint,
        prevLastPoint,
        action.payload.elevation
      );

      const newMixingPoint = {
        id: passedMixingPoint.id,
        temperatureDryBulb: temperatureDryBulbMix,
        temperatureWetBulb: temperatureWetBulbCalculatedMixing,
        temperatureDewPoint: 0,
        relativeHumidity: relativeHumidityMix,
        absoluteHumidity: absoluteHumidityMix,
        enthalpy: enthalpyMix,
        airFlowHours: normalFlowMix,
        airFlowSeconds: normalFlowMix / 3600,
        massFlow: massFlowMix,
        realFlow: realFlowMix,
        airDensity: airDensityMix,
        usedPower: usedPowerMix,
        usedWater: usedWaterMix,
        process: 30,
      };
      updatedArray[passedMixingPoint.id] = newMixingPoint;

      return {
        ...state,
        winterPoints: updatedArray,
      };
    case actions.ADD_OR_UPDATE_STEAMHUMIDITYPOINT_WINTER:
      const passedSteamPoint = state.summerPoints.find(
        (item) => item.id === action.payload.processID
      );

      const pointForCalculationSteam =
        state.summerPoints[action.payload.processID - 1];
      const {
        temperatureDryBulb: temperatureDryBulbSteam,
        temperatureWetBulbCalculated: temperatureWetBulbCalculatedSteam,
        relativeHumidity: relativeHumiditySteam,
        absoluteHumidity: absoluteHumiditySteam,
        enthalpy: enthalpySteam,
        massFlow: massFlowSteam,
        realFlow: realFlowSteam,
        normalFlow: normalFlowSteam,
        airDensity: airDensitySteam,
        usedPower: usedPowerSteam,
        usedWater: usedWaterSteam,
      } = calculateTableDataForSteamHumidify(
        action.payload.relativeHumidity,
        action.payload.elevation,
        passedSteamPoint.id === 2 ? outdoorPoint : pointForCalculationSteam
      );

      const newPointSteam = {
        id: passedSteamPoint.id,
        temperatureDryBulb: temperatureDryBulbSteam,
        temperatureWetBulb: temperatureWetBulbCalculatedSteam,
        temperatureDewPoint: 0,
        relativeHumidity: relativeHumiditySteam,
        absoluteHumidity: absoluteHumiditySteam,
        enthalpy: enthalpySteam,
        airFlowHours: normalFlowSteam,
        airFlowSeconds: normalFlowSteam / 3600,
        massFlow: massFlowSteam,
        realFlow: realFlowSteam,
        airDensity: airDensitySteam,
        usedPower: usedPowerSteam,
        usedWater: usedWaterSteam,
        process: 50,
      };
      updatedArray[passedSteamPoint.id] = newPointSteam;

      return {
        ...state,
        winterPoints: updatedArray,
      };

    case actions.CHANGE_OUTDOOR_POINT_WINTER:
      const { fieldName, value } = action.payload;

      let recalculateOutdoorParams;
      if (fieldName === "temperatureDryBulb")
        recalculateOutdoorParams = {
          temperatureDryBulb: +value,
          relativeHumidity: null,
          airFlowHours: null,
        };
      else if (fieldName === "relativeHumidity")
        recalculateOutdoorParams = {
          temperatureDryBulb: null,
          relativeHumidity: +value,
          airFlowHours: null,
        };
      else
        recalculateOutdoorParams = {
          temperatureDryBulb: null,
          relativeHumidity: null,
          airFlowHours: +value,
        };

      const {
        temperatureWetBulbCalculated,
        absoluteHumidity,
        enthalpy,
        massFlow,
        realFlow,
        airDensity,
      } = calculateTableData(
        recalculateOutdoorParams.temperatureDryBulb ||
          outdoorPoint.temperatureDryBulb,
        outdoorPoint.temperatureWetBulb,
        outdoorPoint.temperatureDewPoint,
        recalculateOutdoorParams.relativeHumidity ||
          outdoorPoint.relativeHumidity,
        0,
        recalculateOutdoorParams.airFlowHours || outdoorPoint.airFlowHours
      );

      const newOutdoorPoint = {
        ...outdoorPoint,
        [fieldName]: +value,
        temperatureWetBulb: temperatureWetBulbCalculated,
        absoluteHumidity: absoluteHumidity,
        enthalpy: enthalpy,
        massFlow: massFlow,
        realFlow: realFlow,
        airDensity: airDensity,
      };
      updatedArray[0] = newOutdoorPoint;

      return {
        ...state,
        winterPoints: updatedArray,
      };

    case actions.CHANGE_INDOOR_POINT_WINTER:
      const { fieldName1, value1 } = action.payload;

      const indoorPoint = state.winterPoints[1];

      let recalculateIndoorParams;
      if (fieldName1 === "temperatureDryBulb")
        recalculateIndoorParams = {
          temperatureDryBulb: +value1,
          relativeHumidity: null,
          airFlowHours: null,
        };
      else if (fieldName1 === "relativeHumidity")
        recalculateIndoorParams = {
          temperatureDryBulb: null,
          relativeHumidity: +value1,
          airFlowHours: null,
        };
      else
        recalculateIndoorParams = {
          temperatureDryBulb: null,
          relativeHumidity: null,
          airFlowHours: +value1,
        };

      const {
        temperatureWetBulbCalculated: temperatureWetBulbCalculatedIndoor,
        absoluteHumidity: absoluteHumidityIndoor,
        enthalpy: enthalpyIndoor,
        massFlow: massFlowIndoor,
        realFlow: realFlowIndoor,
        airDensity: airDensityIndoor,
      } = calculateTableData(
        recalculateIndoorParams.temperatureDryBulb ||
          indoorPoint.temperatureDryBulb,
        indoorPoint.temperatureWetBulb,
        indoorPoint.temperatureDewPoint,
        recalculateIndoorParams.relativeHumidity ||
          indoorPoint.relativeHumidity,
        0,
        recalculateIndoorParams.airFlowHours || indoorPoint.airFlowHours
      );

      const newIndoorPoint = {
        ...indoorPoint,
        [fieldName1]: +value1,
        temperatureWetBulb: temperatureWetBulbCalculatedIndoor,
        absoluteHumidity: absoluteHumidityIndoor,
        enthalpy: enthalpyIndoor,
        massFlow: massFlowIndoor,
        realFlow: realFlowIndoor,
        airDensity: airDensityIndoor,
      };
      updatedArray[1] = newIndoorPoint;

      return {
        ...state,
        winterPoints: updatedArray,
      };

    case actions.ADD_DLL_EHA_POINT_WINTER:
      updatedArray[updatedArray.length] = action.payload;
      return {
        ...state,
        winterPoints: updatedArray,
      };
    case actions.ADD_DLL_SUP_POINT_WINTER:
      const newArrayDll = [
        ...updatedArray.slice(0, 1),
        action.payload,
        ...updatedArray.slice(1),
      ];
      return {
        ...state,
        winterPoints: newArrayDll,
      };

    case actions.ADD_HEATER_SUP_POINT:
      const newArrayDll3 = [
        ...updatedArray.slice(0, 2),
        action.payload,
        ...updatedArray.slice(2),
      ];
      return {
        ...state,
        winterPoints: newArrayDll3,
      };
    case actions.ADD_HEATER_EHA_POINT:
      const newArrayDll4 = [
        ...updatedArray.slice(0, 4),
        action.payload,
        ...updatedArray.slice(4),
      ];
      return {
        ...state,
        winterPoints: newArrayDll4,
      };

    default:
      return state;
  }
}
